// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c13e2b11","355":"1fd05948","455":"ae3e85ab","690":"5f1c0e0b","977":"4b3215a8"}[chunkId] + ".chunk.js";
};